import { v4 as uuidv4 } from 'uuid';
import axios from './axios';
import local from './localStorage';
import { domainName, domainMap, isAstoundSSO, LOGIN_PROVIDER } from '../config';
import setAuthToken from './auth';
import { getBrowserAndOsDetails } from '../global/commonFunctions/getBrowserAndOsDetails';
import sha256 from 'crypto-js/sha256';

type Params = {
    method: string;
    url: string;
    body?: any;
    token?: string;
    params?: any;
    headers?: any;
    auth?: boolean;
    other?: boolean;
    other1?: string;
    contentType?: string;
};
function XORString(string1: string, string2: string) {
    let result = '';
    for (let i = 0; i < string1.length; i++) {
        result += String.fromCharCode(string1.charCodeAt(i) ^ string2.charCodeAt(i % string2.length));
    }
    return result;
}
function getPreSharedKey(): string {
    const key: any = process.env.REACT_APP_EVAL_TOKEN;
    return key.trim();
}
class ApiJunction {
    async makeRequest(params: Params) {
        const resToken = await setAuthToken();
        localStorage.setItem('accessToken', resToken);
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);
        var details = getBrowserAndOsDetails();
        let user: any =
            domainName === domainMap.T2 ? local.getItem('earthlinkCurrentUser') : local.getItem('currentuser');
        user = JSON.parse(user);

        let ssoToken = localStorage.getItem('astoundAccessToken');

        axios.defaults.headers.common['txnid'] = uuidv4();
        axios.defaults.headers.common['x-reach-mvne'] = 'TMOBILE';

        axios.defaults.headers.common['authorization'] = `Bearer ${isAstoundSSO ? true : false}|${ssoToken}`;

        axios.defaults.headers.common[params.auth ? 'x-account-src' : 'x-reach-src'] = params.auth
            ? `reach`
            : `web|${customerDetail?.firstName ? customerDetail?.firstName.toLowerCase() : ''} ${
                  customerDetail?.lastName ? customerDetail?.lastName.toLowerCase() : ''
              }|${customerDetail?.emailId}|customer|${details.browser}/${details.browserVersion}|${
                  details.operatingSystem
              }/${details.osVersion}|${LOGIN_PROVIDER.SSO}`;

        if (params.contentType) {
            axios.defaults.headers.post['Content-Type'] = params.contentType;
        } else {
            axios.defaults.headers.common['Content-Type'] = `application/x-www-form-urlencoded; charset=UTF-8`;
            axios.defaults.headers.patch['Content-Type'] = `application/x-www-form-urlencoded; charset=UTF-8`;
        }
        if (params.other) {
            axios.defaults.headers.common['x-is-primary'] = params.other ? 'Yes' : 'No';
        }
        if (params.other1) {
            axios.defaults.headers.common['x-reach-mvne'] = params.other1 ? params.other1 : '';
        }
        const date = Date.now();
        let firstName = customerDetail?.firstName || '';
        let lastName = customerDetail?.lastName || '';
        let emailId = customerDetail?.emailId || '';
        let body = params?.method === 'get' ? '' : JSON.stringify(params?.body);
        const xreach = `${firstName ? firstName.toLowerCase() : ''}${lastName ? lastName?.toLowerCase() : ''}|${
            emailId ? emailId : ''
        }|customer|${details.browser}/${details.browserVersion}|${details.operatingSystem}/${details.osVersion}|${
            LOGIN_PROVIDER.SSO
        }`.trim();
        const headersToHash = JSON.stringify({
            xReachSrc: `web|${xreach.replace(/ /g, '')}`,
            authorization: `Bearer true|${ssoToken ? ssoToken : params?.token}`,
            xReachDate: date?.toString(),
        })?.trim();

        const preDefinedKey = getPreSharedKey();
        const queryParams = params?.url.split('?')[1];
        const param = queryParams ? queryParams : '';
        const path = params.url.split('?')[0];
        const url = `${process.env.REACT_APP_SERVER_ADDRESS}${path}`;
        let dataToHash;
        if (body) {
            dataToHash = `${url.replace(/ /g, '')}${headersToHash}${body}${param}`;
        } else {
            dataToHash = `${url.replace(/ /g, '')}${headersToHash}${param}`;
        }
        const dataToHashPostXOR = XORString(dataToHash, preDefinedKey);
        const hash: any = sha256(dataToHashPostXOR);
        axios.defaults.headers.common['x-reach-tokenid'] = hash;
        axios.defaults.headers.common['x-reach-date'] = date;
        axios.defaults.headers.common[params.auth ? 'x-account-src' : 'x-reach-src'] = params.auth
            ? `reach`
            : `web|${firstName ? firstName.toLowerCase() : ''}${lastName ? lastName.toLowerCase() : ''}|${
                  emailId ? emailId : ''
              }|customer|${details.browser}/${details.browserVersion}|${details.operatingSystem}/${
                  details.osVersion ? details.osVersion : ''
              }|${LOGIN_PROVIDER.SSO}`;
        console.log(dataToHash, 'dataToHash');
        if (params.method === 'get') {
            return axios.get(params.url, { params: params.params });
        } else if (params.method === 'post') {
            return axios
                .post(params.url, params.body)
                .then((res: any): any => {
                    if (res.code === 200) {
                        return res.data;
                    }
                    return res;
                })
                .then(err => {
                    return err;
                });
        } else if (params.method === 'put') {
            return axios.put(params.url, params.body);
        } else if (params.method === 'delete') {
            return axios.delete(params.url, params.body);
        } else if (params.method === 'patch') {
            return axios.patch(params.url, params.body, params.headers);
        } else {
            return { success: false, msg: 'No method provided, get, post?' };
        }
    }

    login(params: Params) {
        return axios.post(params.url, params.body);
    }
}

export default new ApiJunction();
